import { LocalizedSmallParagraph, LocalizedSubsectionTitle } from '@mews-commander/ui';
import { TextKey, DataTestId, RouteName } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button, Card, Stack } from '@optimus-web/core';
import { useResolveRoute } from '@mews/routing';
import { openInBrowserTab } from '@mews-commander/utils';

interface CapitalBannerForPayoutReportProps {
    hasBannerTitle: boolean;
}

export const CapitalBannerForPayoutReport = ({ hasBannerTitle }: CapitalBannerForPayoutReportProps) => {
    const resolveRoute = useResolveRoute();

    const url = resolveRoute(RouteName.FinancialServicesCapital);

    return (
        <Card padding="200" data-test-id={DataTestId.CapitalBannerForPayoutReport}>
            <Stack vertical spacing="200" itemAlignment="start">
                {hasBannerTitle && (
                    <LocalizedSubsectionTitle textKey={TextKey.FinancialServicesBannerGetFinancialBoost} />
                )}
                <LocalizedSmallParagraph textKey={TextKey.FinancialServicesBannerApplyOnline} variant="secondary" />
                <Button
                    variant="primary"
                    onClick={() => openInBrowserTab(url)}
                    data-test-id={DataTestId.CapitalBannerForPayoutReportButton}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.FinancialServicesBannerLearnMore} />
                </Button>
            </Stack>
        </Card>
    );
};
